import React, {useState, useContext, useEffect} from 'react';
import { IonText, IonGrid, IonRow, IonCol, IonButton, IonModal, IonContent, IonList, IonItem, IonInfiniteScroll, IonInfiniteScrollContent, IonHeader, IonFooter } from '@ionic/react';
import ReactDOM from 'react-dom';


import { Auth_MerchantID_context } from '../../../../storeState/auth_merchantID_context';
import { ConsultationDetailsModal } from './Modal_Consultation_Details';

//import classes from './Modal_ViewModal.module.css';
import '../../../../css/qavaApp.css';

const Backdrop = props => {
    return <div className='backdrop'/>
};

export function ViewConsultationListModal(props) {

    let authenticatedMerchent_context = useContext(Auth_MerchantID_context);


    const [acctID, setAcctID ] = useState(authenticatedMerchent_context.acctID);
    let [sessionID, setSessionID ] = useState(authenticatedMerchent_context.sessionID);
    let [baseURL, setBaseURL ] = useState(authenticatedMerchent_context.baseURL);

    let [startDate, setStartDate] = useState(props.startDate);
    let [endDate, setEndDate] = useState(props.endDate);

    let [viewConsultations, setViewConsultations] = useState([]);

    let [consultationID, setConsultationID] = useState(null);
    let [totalAmount, setTotalAmount] = useState(null);

    let [showConsultationDetailsModal, setShowConsultationDetailsModal] = useState(false);

    useEffect(() => {


            const requestOptions = {
                method: 'POST',
                //credentials: 'include',
                headers: {
                    'Accept': 'text/html, application/json',
                    'content-type': 'application/json',
                    //'cookie': 'cookie',
                },
                body: JSON.stringify({
                    Tracker: '74101_view_consultation_list',
                    user: acctID,
                    xStartDateRange: props.startDate.toISOString().substr(0, 10),
                    xEndDateRange: props.endDate.toISOString().substr(0, 10),
                    sessionID: sessionID,
    
                }),
            }

            
            fetch(baseURL+'proService_merchantAcct_argsjqApp', requestOptions)
            .then(res => res.text())
            .then(res => {

                let rows = res.toString().split('~~~');

                for (let rownum = 0; rownum < rows.length - 1; ++rownum)
                {
                    let cols = rows[rownum].split('|');

                    setViewConsultations((prevAvailableRooms) => {
                        return prevAvailableRooms.concat({
                            consultationID: cols[0],
                            customerAccountID: cols[1],
                            estimateID: cols[2],
                            customerFirstName: cols[3],
                            customerLastName: cols[4],
                            customerMobileNumber: cols[5],
                            estimateDescription: cols[6],
                            estimateLatitude: parseFloat(cols[7]).toFixed(2),
                            estimateLongitude: cols[8],
                            dateLogged: cols[9],
                            estimateImage1: cols[10],
                            status: cols[11],
                            externalID: cols[12],
                        })
                    });
                } 
            })
        
    }, []);

    function deleteConsultation(enteredPassword)
    {

        const requestOptions = {
            method: 'POST',
            //credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                'content-type': 'application/json',
                //'cookie': 'cookie',
            },
            body: JSON.stringify({
                Tracker: '74101_delete_consultation',
                user: acctID,
                xConsultationID: consultationID,
                xEnterAdminPassword: enteredPassword,
                sessionID: sessionID,

            }),
        }

        fetch(baseURL+'hotel_merchantAcct_argsjqApp', requestOptions)
        .then(res => res.text())
        .then(data => {

            alert(data);

            props.closeModal(false);

        })
        .catch(error => {
            console.error(error);
        })
    }

    function closeModalHandler(event) {

        setViewConsultations([]);
        props.closeModal(event);
    }
 
    function viewConsultationDetailsHandler(event) {


        setConsultationID(event[1]);
        setShowConsultationDetailsModal(event[0]);

        //setRoomID(event[1]);
        //setRoomSalePrice(event[2]);
    }

    function viewDeleteConsultationHandler(event) {


        //setShowPasswordModal(event[0]);
        setConsultationID(event);
    }

    function onSubmitPasswordHandler(event)
    {
        deleteConsultation(event);
    }



    return (

        <React.Fragment> 
           
            {props.openModal == true ?
            (
                <div>
                {ReactDOM.createPortal(<Backdrop />, document.getElementById('backdrop-root'))}

                <IonModal isOpen={ props.openModal }>
                    <IonHeader className='appModalHeader'>
                        <h3> One-Time Consultations </h3>
                    </IonHeader>

                    <IonContent >
                        <IonGrid className='appGridContent'>
                            <IonRow >
                                    <IonCol size='4'> <h3> Customer Name </h3> </IonCol>
                                    {/*<IonCol className='appGridCol' size='2'> <h3> Supplier Phone </h3> </IonCol>*/}
                                    {/*<IonCol className='appGridCol' size='3'> <h3> Consultation Description </h3> </IonCol>*/}
                                    <IonCol size='4'> <h3> Date Logged </h3> </IonCol>
                                    <IonCol size='4'> <h3> Action </h3> </IonCol>
                            </IonRow>
                        {viewConsultations.map((detailData) =>   {
                            return (
                                    <IonRow key={detailData.consultationID}>
                                        <IonCol size='4'>{detailData.customerFirstName} {detailData.customerLastName}</IonCol>
                                        {/*<IonCol className='appGridCol' size='2'>{detailData.supplierPhoneNumber}</IonCol>*/}
                                        {/*<IonCol className='appGridCol' size='3'>{detailData.expenseDescription}</IonCol>*/}
                                        <IonCol size='4'>{detailData.dateLogged}</IonCol>
                                        <IonCol size='4'>

                                            <IonButton className='appListButton' onClick={() => viewConsultationDetailsHandler([true, detailData.consultationID])}> Details </IonButton>
                                            {authenticatedMerchent_context.accessRights[0] == 'admin' && <IonButton className='appListButton' onClick={() => viewDeleteConsultationHandler(detailData.consultationID)}> Delete </IonButton>}
                                            {/*<IonButton class='gridResultColumnButton' onClick={() => setViewAttachemntModal(true)}> View Invoice</IonButton>*/}
                                    
                                        </IonCol>

                                        {showConsultationDetailsModal == true && <ConsultationDetailsModal openModal={ showConsultationDetailsModal } closeModal={() => setShowConsultationDetailsModal(false)} data={{
                                            customerAccountID: detailData.customerAccountID, 
                                            consultationID: detailData.consultationID, 
                                            externalID: detailData.externalID,
                                            userStatus: "member",
                                            }}></ConsultationDetailsModal>}
                                    </IonRow>
                            )
                        }
                        )}
                        </IonGrid>


                    </IonContent>

                    <IonFooter className='modal_footer_button_center'>
                        <IonButton onClick={() => closeModalHandler(false)}> Close </IonButton>
                    </IonFooter>

                </IonModal>            
            </div>
            ) : null }

        </React.Fragment>

    )
}